module.exports = {
    name:      "magic_bingo",
    buildDate: "Sun Jan 26 2020 21:54:52 GMT+0000 (GMT)",
    version:   "1.0.0",
    build:     "26.2717 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 12
// module chunks = 0